const SHOP_ROLES = ['default-user', 'oms-shop-manager']

const SHOP_ROLE_LABEL_KEYS = {
  'default-user': 'users.seller',
  'oms-shop-manager': 'users.shopManager',
}

/**
 * Seller and shop-manager options for an order-settings role picker.
 * Same two roles as the shop-level lists already used on the display settings screen.
 * @param {function(string): string} translate i18n translate function
 * @returns {{text: string, value: string}[]}
 */
export function shopLevelRoleOptions(translate) {
  return SHOP_ROLES.map((value) => {
    return { text: translate(SHOP_ROLE_LABEL_KEYS[value]), value }
  })
}

/**
 * Shop roles allowed to cancel this to_pickup order from the pickup country's settings.
 * An e-reservation uses pickup_ebooking_cancel_roles when that key is present, including an empty list.
 * While the key is absent, a legacy switch left on keeps both shop roles, and a switch left off allows none.
 * Every other order type uses pickup_order_cancel_roles. A missing list allows nobody.
 * Missing settings allow nobody.
 * @param {object} order order whose type selects the list
 * @param {object|null|undefined} settings country settings of the pickup location
 * @returns {string[]}
 */
export function resolvePickupCancelRoles(order, settings) {
  if (!settings) {
    return []
  }
  const permissions = settings.permissions && typeof settings.permissions === 'object' ? settings.permissions : {}
  if (order && order.type === 'click_and_reserve') {
    if (Object.prototype.hasOwnProperty.call(permissions, 'pickup_ebooking_cancel_roles')) {
      if (Array.isArray(permissions.pickup_ebooking_cancel_roles)) {
        return permissions.pickup_ebooking_cancel_roles
      }
      return []
    }
    // A stored document without the switch reads back as the schema default, which is on.
    const legacyOn = !settings.display || settings.display.display_cancel_order_button !== false
    if (legacyOn) {
      return SHOP_ROLES.slice()
    }
    return []
  }
  if (Array.isArray(permissions.pickup_order_cancel_roles)) {
    return permissions.pickup_order_cancel_roles
  }
  return []
}

/**
 * Roles shown in the e-reservation field before the first save of that field.
 * @param {object|null|undefined} settings loaded country settings
 * @returns {string[]}
 */
export function initialEbookingCancelRoles(settings) {
  return resolvePickupCancelRoles({ type: 'click_and_reserve' }, settings)
}
